// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export { default as CodeView } from "./code-view";
export type { CodeViewProps } from "./code-view";
